'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { useForm, useWatch } from 'react-hook-form'

import { TFindID, ZFindID } from '@/entities/auth'
import { Button, Form } from '@/shared/ui'

import { useFindID } from '../api/find-id'

const defaultValues: TFindID = {
  name: '',
  phoneNumber: '',
}

export const FindIDForm = ({
  onSuccess,
}: {
  onSuccess: (username: string) => void
}) => {
  const form = useForm<TFindID>({
    resolver: zodResolver(ZFindID),
    defaultValues,
    reValidateMode: 'onSubmit',
  })

  const [name, phoneNumber] = useWatch({
    control: form.control,
    name: ['name', 'phoneNumber'],
  })

  const isDisabled = !name || !phoneNumber

  const findID = useFindID({
    form,
    onSuccess: ({ username }) => {
      onSuccess(username)
    },
  })

  const submitForm = (data: TFindID) => {
    findID.execute(data)
  }

  return (
    <Form.Root form={form}>
      <Form.Field name="name">
        <Form.Label className="font-medium text-black">이름</Form.Label>
        <Form.TextField
          type="text"
          placeholder="이름을 입력해 주세요"
          fullWidth
        />
        <Form.Message />
      </Form.Field>

      <Form.Field name="phoneNumber" className="mt-6">
        <Form.Label className="font-medium text-black">휴대폰 번호</Form.Label>
        <Form.TextField
          type="tel"
          placeholder="휴대폰 번호를 입력해 주세요"
          fullWidth
        />
        <Form.Message className="whitespace-break-spaces" />
      </Form.Field>

      <Button
        size="large"
        className="mt-10 mb-2.5"
        type="submit"
        fullWidth
        onClick={form.handleSubmit(submitForm)}
        disabled={isDisabled}
      >
        확인
      </Button>
    </Form.Root>
  )
}
